import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

interface ProfileClaimedDialogProps {
  isOpen: boolean;
  onClose: () => void;
  companyName?: string;
}

export function ProfileClaimedDialog({
  isOpen,
  onClose,
  companyName,
}: ProfileClaimedDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
            <CheckCircle className="h-8 w-8 text-green-600" />
          </div>
          <DialogTitle className="text-2xl font-bold text-green-600">
            Profile Claimed!
          </DialogTitle>
          <DialogDescription className="text-lg">
            {companyName
              ? `You have successfully claimed your profile and are now managing ${companyName}.`
              : "You have successfully claimed your profile and are now ready to manage your company."}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-6 text-center">
          <Button onClick={onClose} className="w-full">
            Continue to Sign In
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
